import React from 'react';
import Header from '@/components/layout/Header';
import CollectionsProtectedRoute from '@/components/layout/CollectionsProtectedRoute';
import { OptimizedCollectionsManagement } from '@/components/collections/OptimizedCollectionsManagement';
import { ProcurementErrorBoundary } from '@/components/common/ProcurementErrorBoundary';

/**
 * Collections Page - Global Collections across all projects
 * Following Subcons architecture pattern
 */
export default function Collections() {
  return (
    <CollectionsProtectedRoute>
      <div className="min-h-screen bg-background">
        <Header />
        <main className="container mx-auto py-6">
          <ProcurementErrorBoundary>
            <OptimizedCollectionsManagement />
          </ProcurementErrorBoundary>
        </main>
      </div>
    </CollectionsProtectedRoute>
  );
}
